import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta ">
    <div className="gpt3__cta-content">
      <p>Demander un accès anticipé</p>
      <h3>Inscrivez-vous dès aujourd'hui et commencez à explorer les possibilités infinies.</h3>
    </div>
    <div className="gpt3__cta-btn">
      <button type="button">Commencez</button>
    </div>
  </div>
);

export default CTA;